import { Box, TextField, Typography } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const ExperienceLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "experience_letter_date" || key === "joining_date" ||
            key === "last_working_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>


            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2,
                }}
            >

                <Box>
                    <TextField
                        fullWidth
                        type="date"
                        label="Experience Letter Date"
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.experience_letter_date ? formatDateForInput(data.experience_letter_date) : ""}
                        onChange={(e) => handleChange("experience_letter_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        fullWidth
                        type="date"
                        label="Joining Date"
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.joining_date ? formatDateForInput(data.joining_date) : ""}
                        onChange={(e) => handleChange("joining_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        label="First Designation"
                        value={data.first_designation || ""}
                        onChange={(e) => handleChange("first_designation", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        fullWidth
                        type="date"
                        label="Last Working Date"
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.last_working_date ? formatDateForInput(data.last_working_date) : ""}
                        onChange={(e) => handleChange("last_working_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        label="Last Designation"
                        value={data.last_designation || ""}
                        onChange={(e) => handleChange("last_designation", e.target.value)}
                    />
                </Box>

                {/* <Box>
                    <TextField
                        fullWidth
                        type="number"
                        label="Number of Promotions"
                        value={data.number_of_promotion || ""}
                        onChange={(e) => handleChange("number_of_promotion", e.target.value)}
                    />
                </Box> */}
            </Box>
        </Box>
    );
};

export default ExperienceLetterForm;
